//Polyfill
import "core-js";
import jQuery from "jquery";

// Swiper
import Swiper from "swiper";
import { Autoplay, FreeMode } from "swiper/modules";

const $ = jQuery;

$(document).ready(function () {
  // Mobile menu toggle
  $(".js-header-trigger").click(function () {
    $(this).toggleClass("open");
    $(".js-header-sp-nav").toggleClass("open");
  });

  // Header scroll behavior
  const $header = $(".header");
  let lastScrollTop = 0;

  $(window).on("scroll", function () {
    if (!$header.hasClass("header--home")) return;

    const scrollTop = $(this).scrollTop() || 0;
    const docHeight = $(document).height() || 0;
    const scrollThreshold = docHeight * 0.3; // ページ全体の30%を基準にする

    if (scrollTop > scrollThreshold) {
      if (scrollTop > lastScrollTop) {
        // Scrolling down
        $header.addClass("is-visible");
      } else {
        // Scrolling up
        $header.removeClass("is-visible");
      }
    } else {
      // Below threshold
      $header.removeClass("is-visible");
    }

    // 0（最上部）付近では必ず非表示（不自然な挙動を防ぐ）
    if (scrollTop <= 0) {
      $header.removeClass("is-visible");
    }

    lastScrollTop = scrollTop;
  });

  // Close mobile menu when a link is clicked
  $(".js-header-sp-nav a").click(function () {
    $(".js-header-trigger, .js-header-sp-nav").removeClass("open");
  });

  // Ticker speed calculation based on slide width (to keep constant px/s)
  const PIXELS_PER_SECOND = 50;
  const NEWS_PIXELS_PER_SECOND = 300; // NEWS用の速度設定
  const NEWS_PIXELS_PER_SECOND_SP = 80; // NEWS用の速度設定 (SP)
  const calculateSpeed = (selector: string, pps: number = PIXELS_PER_SECOND) => {
    const $el = $(selector);
    const $slide = $el.find(".swiper-slide").first();
    const width = $slide.outerWidth() || 500;
    return (width / pps) * 1000;
  };

  // Ticker Swiper 1 (Right Slide)
  const ticker1 = new Swiper(".js-ticker-swiper-1", {
    modules: [Autoplay, FreeMode],
    loop: true,
    slidesPerView: "auto",
    loopAdditionalSlides: 5,
    speed: calculateSpeed(".js-ticker-swiper-1"),
    allowTouchMove: false,
    watchSlidesProgress: true,
    autoplay: {
      delay: 0,
      reverseDirection: true,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    freeMode: {
      enabled: true,
      momentum: false,
    },
  });

  // Ticker Swiper 2 (Left Slide)
  const ticker2 = new Swiper(".js-ticker-swiper-2", {
    modules: [Autoplay, FreeMode],
    loop: true,
    slidesPerView: "auto",
    loopAdditionalSlides: 5,
    speed: calculateSpeed(".js-ticker-swiper-2"),
    allowTouchMove: false,
    watchSlidesProgress: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    freeMode: {
      enabled: true,
      momentum: false,
    },
  });

  // Ticker Swiper Top (MV)
  const tickerTop = new Swiper(".js-ticker-swiper-top", {
    modules: [Autoplay, FreeMode],
    loop: true,
    slidesPerView: "auto",
    loopAdditionalSlides: 5,
    speed: calculateSpeed(".js-ticker-swiper-top"),
    allowTouchMove: false,
    watchSlidesProgress: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    freeMode: {
      enabled: true,
      momentum: false,
    },
  });

  // News Swiper
  const tickerNews = new Swiper(".swiper-news", {
    modules: [Autoplay, FreeMode],
    loop: true,
    loopAdditionalSlides: 2,
    watchSlidesProgress: true,
    speed: calculateSpeed(".swiper-news", window.innerWidth < 768 ? NEWS_PIXELS_PER_SECOND_SP : NEWS_PIXELS_PER_SECOND),
    slidesPerView: 1.25,
    spaceBetween: 30,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    freeMode: {
      enabled: true,
      momentum: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: false,
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 30,
        centeredSlides: false,
      },
    },
  });

  // Ensuring autoplay starts properly
  setTimeout(() => {
    if (ticker1 && ticker1.autoplay) ticker1.autoplay.start();
    if (ticker2 && ticker2.autoplay) ticker2.autoplay.start();
    if (tickerTop && tickerTop.autoplay) tickerTop.autoplay.start();
    if (tickerNews && tickerNews.autoplay) tickerNews.autoplay.start();
  }, 100);
});
